import { ApolloError } from '@apollo/client';
import { useCallback } from 'react';

import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { isNotFoundError } from '@/graphql/errors';

interface UseRecordNotFoundHandlerOptions {
  message: string;
  onNotFound: () => void;
}

export function useRecordNotFoundHandler({
  message,
  onNotFound,
}: UseRecordNotFoundHandlerOptions) {
  const { showFeedback } = useFeedback();

  const recoverMissingRecord = useCallback(() => {
    showFeedback(message, { variant: 'warning' });
    onNotFound();
  }, [message, onNotFound, showFeedback]);

  const recoverExpectedNotFound = useCallback(
    (error: ApolloError) => {
      if (!isNotFoundError(error) || error.networkError) {
        return false;
      }

      recoverMissingRecord();
      return true;
    },
    [recoverMissingRecord]
  );

  return { recoverExpectedNotFound, recoverMissingRecord };
}
